module.exports = __webpack_public_path__ + "static/media/vf_wcardigan_core.470112f9.svg";